// extracted by mini-css-extract-plugin
module.exports = {"disableLink":"styles_disableLink__yaw8m","navTabs":"styles_navTabs__18RHC"};